import Axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from ".";
import { addRatesASE } from "../redux/slices/Rate/rate";
import { searchSelector } from "../redux/slices/Search/search";
import { buildFetchRatesUrl, fetchRoomsAndRatesASE } from "../services/rates";
import { addHotelsAvailabilityGTMDataLayer } from "../utils/datalayers";

export const useHotelRates = (
  hotel: { crsHotelCode: string; crsName: string },
  addGTM = false,
  siteID = "31"
): [undefined, unknown] => {
  const dispatch = useAppDispatch();
  const search = useAppSelector(searchSelector);
  const rates = useAppSelector(
    (state) => state.rates && state.rates[hotel.crsHotelCode]
  );
  const isMountedRef = useRef(null);
  // ASE - Availibilty Call
  const apiUrl = buildFetchRatesUrl(
    hotel.crsName,
    hotel.crsHotelCode,
    search.checkin,
    search.checkout,
    search.rooms[0].adults,
    search.rooms[0].children,
    search.promotionCode,
    search.groupCode,
    null,
    search.rooms[0].childrenAges,
    search.ratePlanFilterCode,
    search.discount,
    null,
    siteID
  );
  const [searchQuery, setSearchQuery] = useState(apiUrl);
  const [isLoadingRates, setIsloadingRates] = useState();
  const [isDataLayer, setIsDataLayer] = useState(false);

  // const price = hotel.bestPrice !== null ? hotel.bestPrice : null;

  const fetchRates = async (abortController) => {
    if (!isMountedRef.current) {
      return;
    } else {
      setIsloadingRates(true);
      let getNewRates = false;
      if (rates !== null && rates !== undefined) {
        // Check if search filters changed.
        if (searchQuery !== rates.searchQuery) {
          getNewRates = true;
        } else {
          getNewRates = true;
        }
      }
      // No rates in redux.
      else {
        getNewRates = true;
      }
      if (getNewRates) {
        if (isMountedRef.current) {
          setIsloadingRates(true);
          await dispatch(
            addRatesASE(
              apiUrl,
              search.rooms[0].adults,
              search.rooms[0].children,
              search.rooms[0].childrenAges,
              hotel.crsHotelCode,
              hotel.crs_chain_id,
              search.checkin,
              search.checkout,
              "NonRoom",
              search.promotionCode,
              search.groupCode,
              search.discount || search.ratePlanFilterCode || "Retail",
              false, //isLoggedIn -- false/true doesn't matter here
              false, //isHotelPage
              abortController
            )
          );
          if (isMountedRef.current) {
            setSearchQuery(apiUrl);
            setIsloadingRates(false);
          }
        }
      }
      setIsloadingRates(false);
    }
  };

  useEffect(() => {
    isMountedRef.current = true;
    const abortController = new AbortController();
    const source = Axios.CancelToken.source();
    (async () => {
      await fetchRates(abortController);
    })();
    const intervalId = setInterval(async () => {
      await fetchRates(abortController);
    }, 300000);
    // Cleanup on unmount.
    return () => {
      clearInterval(intervalId);
      isMountedRef.current = false;
      source.cancel(`Request cancelled for ${apiUrl}`);
      abortController.abort();
    };
  }, [searchQuery]);

  let selectedRoom = null;
  if (rates !== null && rates !== undefined) {
    let soldout = true;
    if (rates.Rooms) {
      const parsedRooms = fetchRoomsAndRatesASE(
        rates.Rooms,
        search.discount,
        search.promotionCode,
        search.groupCode,
        search.checkin,
        search.checkout,
        rates?.redemptionItem
      );
      if (parsedRooms !== null) {
        selectedRoom = parsedRooms[0];
      }
      if (rates.Rooms && parsedRooms) {
        soldout = false;
      }
    }
    if (!isLoadingRates && isMountedRef.current && addGTM && !isDataLayer) {
      addHotelsAvailabilityGTMDataLayer(hotel, search, soldout);
      setIsDataLayer(true);
    }
  }

  return [isLoadingRates, selectedRoom];
};
